(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dw-product-template-compatible-products"] && !Shopify.designMode) return;
  try {
    // A variant change puts in the block of the new variant (renderProductInfo in template-product.js), and a colour of another product puts in the
  // whole section: the listeners are on the document and look the elements up each time
  const compatibleParts = () => {
    const productsContainer = document.getElementById('compatible-products-list')
    const showingProducts = !!productsContainer && !productsContainer.hidden
    const filterStrapsSelect = document.getElementById('compatible-filter-straps-select')
    const filterJewellerySelect = document.getElementById('compatible-filter-jewellery-select')
    return {
      loadMoreButton: document.getElementById('compatible-load-more'),
      filterStrapsSelect,
      filterJewellerySelect,
      strapsBtn: document.getElementById('compatible-toggle-straps'),
      jewelleryBtn: document.getElementById('compatible-toggle-jewellery'),
      productsContainer,
      jewelleryContainer: document.getElementById('compatible-jewellery-list'),
      activeScope: showingProducts ? '#compatible-products-list' : '#compatible-jewellery-list',
      activeFilter: showingProducts ? filterStrapsSelect : filterJewellerySelect
    }
  }

  // The cards beyond the first ones are in a <template> (see dw-render-compatible-product-cards.liquid); put them in the list of the active tab
  const expandRest = (scopeSelector) => {
    document.querySelectorAll(`${scopeSelector} template.compatible-rest`).forEach(template => template.replaceWith(template.content))
  }

  const applyFilter = (toLoad) => {
    const { loadMoreButton, activeScope, activeFilter } = compatibleParts()
    expandRest(activeScope)
    if (!toLoad) {
      toLoad = loadMoreButton ? parseInt(loadMoreButton.dataset.loadMore) : Infinity
    }
    if (!activeFilter) return
    const val = (activeFilter.value || '').toLowerCase()

    const cards = document.querySelectorAll(`${activeScope} compatible-card`)

    let showCount = 0
    let filteredCount = 0
    cards.forEach(card => {
      const type = (card.dataset.productType || '').toLowerCase()
      if (!val || val === '' || type === val) {
        filteredCount++
        if(loadMoreButton && showCount >= toLoad) {
          card.hidden = true
          return
        }
        card.hidden = false
        showCount++
      } else {
        card.hidden = true
      }
    })

    if (loadMoreButton) {
      loadMoreButton.hidden = showCount >= filteredCount
    }
  }

  const selectTab = (chosen, other) => {
    if (chosen) { chosen.setAttribute('aria-selected', 'true'); chosen.tabIndex = 0 }
    if (other) { other.setAttribute('aria-selected', 'false'); other.tabIndex = -1 }
  }

  const setActiveTab = (target) => {
    const { filterStrapsSelect, filterJewellerySelect, strapsBtn, jewelleryBtn, productsContainer, jewelleryContainer } = compatibleParts()
    const showProducts = target === 'products'
    if (productsContainer) productsContainer.hidden = !showProducts
    if (jewelleryContainer) jewelleryContainer.hidden = showProducts
    if (showProducts) selectTab(strapsBtn, jewelleryBtn)
    else selectTab(jewelleryBtn, strapsBtn)
    if (filterJewellerySelect) filterJewellerySelect.classList.toggle('hidden', showProducts)
    if (filterStrapsSelect) filterStrapsSelect.classList.toggle('hidden', !showProducts)
    applyFilter()
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return
    const tab = event.target.closest('#compatible-toggle-straps, #compatible-toggle-jewellery')
    if (tab) {
      setActiveTab(tab.id === 'compatible-toggle-straps' ? 'products' : 'jewellery')
      return
    }
    const loadMoreButton = event.target.closest('#compatible-load-more')
    if (loadMoreButton) {
      const { activeScope } = compatibleParts()
      expandRest(activeScope)
      const hiddenCards = document.querySelectorAll(`${activeScope} compatible-card[hidden]`)
      const totalCards = document.querySelectorAll(`${activeScope} compatible-card`).length
      applyFilter(totalCards - hiddenCards.length + parseInt(loadMoreButton.dataset.loadMore))
    }
  })

  // arrow keys move between the tabs
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
    if (!(event.target instanceof Element)) return
    const tab = event.target.closest('#compatible-toggle-straps, #compatible-toggle-jewellery')
    if (!tab) return
    const { strapsBtn, jewelleryBtn } = compatibleParts()
    const next = tab === strapsBtn ? jewelleryBtn : strapsBtn
    if (!next) return
    next.focus()
    next.click()
  })

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return
    if (event.target.matches('#compatible-filter-straps-select, #compatible-filter-jewellery-select')) applyFilter()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-bar"] && !Shopify.designMode) return;
  try {
    /* <product-buy-bar>: shown when the main add to cart button is out of view (and the page was scrolled a little, or the bar has data-on-load), hidden again when the button
     or the footer is in view. The product and the bundle template render this snippet, so both get the same code. */
  if (!customElements.get('product-buy-bar')) {
    class ProductBuyBar extends HTMLElement {
      constructor() {
        super();

        const visibleClass = 'is-visible';
        const addToCartContainer = document.querySelector('[data-add-to-cart-container]');
        if (!addToCartContainer) return;

        const show = () => {
          this.classList.add(visibleClass);
          document.dispatchEvent(new CustomEvent('productBuyBar:onVisible'));
        };

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // add to cart (or the footer) is in view: hide the bar
                this.classList.remove(visibleClass);
                document.dispatchEvent(new CustomEvent('productBuyBar:onHidden'));
              } else if (this.hasAttribute('data-on-load') || window.scrollY > 200) {
                // out of view: show the bar right away (data-on-load) or once the page was scrolled a little
                show();
              }
            });
          },
          { threshold: 0.25 }
        );

        observer.observe(addToCartContainer);

        // the footer is observed once the DOM is ready (a script of the platform can run after the page is parsed: then it is ready already)
        const observeFooter = () => {
          const siteFooter = document.querySelector('footer.footer');
          if (siteFooter) observer.observe(siteFooter);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeFooter);
        else observeFooter();
      }
    }

    customElements.define('product-buy-bar', ProductBuyBar);
  }
  } catch(e) { console.error(e); }
})();

})();
